<template>
  <div class="main">
    <layout />
    <!-- 头部信息 -->
    <TopbgVue :title="title" :text="text" />
    <div class="info-li">
      <div class="infotitle">
        <h3>{{ title }}</h3>
        <div class="infoding">
          <span>24-01-04发布</span>
          <span>19次浏览</span>
          <span>信息编号20</span>
        </div>
      </div>
      <div class="person">
        <div class="f1">
          <p class="name">联系人：李先生</p>
          <p class="pgone">电话：13097095633</p>
        </div>
        <div class="f2">
          <img src="../assets/nophoto.png" alt="" />
          <div class="name">李先生</div>
        </div>
      </div>
      <div class="info-de">
        <h3>信息详情</h3>
        <div class="info-de-text">{{ detail }}</div>
      </div>
      <!-- 推荐信息 -->
      <div class="tuijian">
        <h3>推荐信息</h3>
        <div class="ul">
          <router-link
            v-for="(item, index) in tuijian"
            :key="index"
            :to="{
              path: '/detail',
              query: {
                title: item.title,
                text: item.detail[0],
                detail: item.text,
              },
            }"
          >
            <div class="li">
              <img :src="item.img" alt="" />
              <div class="info">
                <div class="info-tit">{{ item.title }}</div>
                <div class="text">{{ item.text }}</div>
                <div class="text">{{ item.detail[1] }}</div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import TopbgVue from "./Topbg.vue";
import Footer from "./footer.vue";
import Layout from "./Layout.vue";
export default {
  name: "Detail",
  data() {
    return {
      title: "",
      text: "",
      detail: "",
      refresh: true,
      tuijian: [
        {
          img: require("../assets/3.png"),
          title: "运达大厦多套写字间出租",
          text: "东港高端写字间出租100-2000平多套空间大，宽敞，小企业用地首选联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！",
          detail: ["房屋出租", "01-01"],
        },
        {
          img: require("../assets/5.png"),
          title: "房屋出租",
          text: "房屋配置：电视,冰箱,床,洗衣机,热水器,宽带,有线,独立卫生间,阳台,可做饭联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！",
          detail: ["房屋出租", "01-02"],
        },
        {
          img: require("../assets/6.png"),
          title: "封闭小区 低楼层 南北通透 采光好",
          text: "核心卖点悦泰福里封闭小区低楼层南北通透采光好拎包入住适宜人群小区环境优美品质高保安24小时值守有电梯地角好楼下还有健身器材。地下停车场。周边配套300米大菜市楼下邮政银行悦泰实验分校，500米凯旋广场晚饭后可以带家人遛弯青泥洼商圈权属抵押此房产权明晰，8月23日满两年。人车分流适合婴幼儿中年和老年人居住，交通出行小区北面是双兴街车站，有40.541等，南面东关街桥洞走过去是411，走到北岗桥车就多了，步行大概900米联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！",
          detail: ["房屋出租", "01-02"],
        },
        {
          img: require("../assets/4.png"),
          title: "双南北2房，中间楼层，中间位置，南北通全明，采光好",
          text: "核心卖点此南北通透中间楼层采光好交通方便近南宁火车站。小区介绍小区近商场近香炉礁商圈近南宁火车站近北京街商圈交通方便购物方便。户型介绍南北通透南卧室中间是客厅还有一个北卧室北厨房采光足。售房详情业主改善换房业主看房方便手续清晰交通方便出行方便。。。。联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！",
          detail: ["房屋出租", "01-04"],
        },
      ],
    };
  },
  components: {
    TopbgVue,
    Footer,
    Layout
  },
  watch: {
    $route: function (to, from) {
      console.log("路由发生了改变");
      console.log("从", from.path, "到", to.path);
      window.location.reload()
      // 这里可以编写处理路由变化的逻辑
    },
  },
  mounted() {
    this.re();
    this.title = this.$route.query.title;
    this.text = this.$route.query.text;
    this.detail = this.$route.query.detail;
  },
  methods: {
    toDetail(item) {
      this.$router.push({
        path: "/detail",
        query: {
          title: item.title,
          text: item.detail[0],
          detail: item.text,
        },
      });
    },
    re() {
      this.refresh = false;
      if (this.refresh) {
        setTimeout(() => {
          window.location.reload(); // 重载当前页面
        }, 300);
        this.refresh = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  .info-li {
    width: 1200px;
    height: auto;
    margin: 0 auto;
    .infotitle {
      h3 {
        font-size: 32px;
      }
      .infoding {
        display: flex;
        align-items: center;
        span {
          display: inline-block;
          margin-right: 30px;
          font-size: 12px;
          color: #717275;
        }
      }
    }
    .person {
      width: 800px;
      height: 400px;
      margin-top: 30px;
      margin-left: 20px;
      border: 1px solid #ddd;
      .f1 {
        width: 100%;
        height: 135px;
        background: #ddd;
        p {
          margin: 0;
          padding-top: 30px;
          padding-left: 20px;
          font-size: 16px;
          color: #717275;
        }
      }
      .f2 {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 30px;
        img {
          width: 135px;
          height: 135px;
          border-radius: 50%;
        }
        .name {
          padding-top: 30px;
          font-size: 16px;
          font-weight: bold;
        }
      }
    }
    .info-de {
      padding-bottom: 30px;
      border-bottom: 1px solid #ddd;
      h3 {
        margin: 20px 0 0;
        font-size: 32px;
      }
      .info-de-text {
        padding: 20px;
        font-size: 32px;
        font-weight: bold;
        background: #ddd;
      }
    }
    .tuijian {
      h3 {
        margin: 20px 0 0;
        font-size: 32px;
      }
      .ul {
        a {
          text-decoration: none;
        }
        .router-link-active {
          text-decoration: none;
        }
        .li {
          cursor: pointer;
          display: flex;
          margin-top: 30px;
          img {
            width: 150px;
            height: 120px;
          }
          .info {
            margin-left: 50px;
            .info-tit {
              font-size: 28px;
              font-weight: bold;
              color: #333333;
            }
            .text {
              padding-top: 10px;
              font-size: 16px;
              line-height: 24px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2; /*省略几行写几*/
              -webkit-box-orient: vertical;
              color: #717275;
            }
          }
        }
      }
    }
  }
}
</style>